import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20artistic%20scene%20of%20a%20woman%20silhouette%20walking%20through%20a%20field%20of%20soft%20golden%20wheat%20at%20sunset%2C%20warm%20amber%20and%20cream%20tones%2C%20dreamy%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20cinematic%20lighting%2C%20emotional%20and%20contemplative%20mood%2C%20soft%20bokeh%20background%2C%20feminine%20aesthetic&width=1800&height=1200&seq=hero-banner-baijie&orientation=landscape"
        alt="少妇白洁——都市情感故事精选集"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      <div className="relative z-10 text-center px-4 w-full max-w-3xl mx-auto">
        <h1 className="text-2xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
          走进<strong>少妇白洁</strong>的内心世界
        </h1>
        <p className="text-sm md:text-lg text-white/80 max-w-xl mx-auto leading-relaxed">
          深入描绘普通女性在婚姻、家庭与自我成长之间的心路历程，展现真实细腻的情感世界
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
          <Link
            to="/category/story-appreciation"
            className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white rounded-full text-sm font-label transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            开始阅读故事
          </Link>
          <Link
            to="/about"
            className="px-6 py-2.5 bg-white/20 hover:bg-white/30 text-white border border-white/30 rounded-full text-sm font-label transition-all duration-300 cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}